/**
 * Drata upload failure codes, shared by the services that push to Drata and the
 * UI that reports the outcome. A push can fail without throwing — these are the
 * ways it comes back unsuccessful — so every surface that renders a result needs
 * the same vocabulary and the same labels.
 */

export const DRATA_UPLOAD_ERRORS = [
  'vendor_not_found',
  'upload_failed',
  'api_error',
  'user_not_found',
  'not_uploadable',
  'key_rejected',
  'multi_workspace_client',
] as const

export type DrataUploadError = (typeof DRATA_UPLOAD_ERRORS)[number]

export const DRATA_UPLOAD_ERROR_LABELS: Record<DrataUploadError, string> = {
  vendor_not_found: 'Vendor not in Drata',
  upload_failed: 'Upload failed',
  api_error: 'API error',
  user_not_found: 'Requesting user not found in Drata',
  not_uploadable: 'Review not uploadable (bridge letter expired)',
  key_rejected: "Drata rejected this client's API key — it may have been revoked or rotated",
  multi_workspace_client:
    'This client has more than one Drata workspace; risks are not pushed to multi-workspace clients yet',
}
